import React from "react";
import { styled } from "@mui/material/styles";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { GetUserReportsResponse } from "../../../models/userReport.model";
import { List, ListItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TabsEmptyStyle from "./TabsEmptyStyle";

interface Props {
  userReportList: GetUserReportsResponse[];
}

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowDropDownIcon sx={{ fontSize: "2rem", color: "#1D4A87" }} />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const Reports = ({ userReportList }: Props) => {
  const [expanded, setExpanded] = React.useState<string | false>("panel1");

  const handleChange = (panel: string) => (
    event: React.SyntheticEvent,
    newExpanded: boolean
  ) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <>
      {userReportList.length > 0 ? (
        <div>
          {userReportList?.map((report, index) => (
            <Accordion
              expanded={expanded === `panel${index + 1}`}
              onChange={handleChange(`panel${index + 1}`)}
            >
              <AccordionSummary
                aria-controls={`panel${index + 1}d-content`}
                id={`panel${index + 1}d-header`}
              >
                <Typography
                  sx={{
                    marginRight: "1.5rem",
                    fontWeight: "bold",
                    color: "#1D4A87",
                  }}
                >
                  {report.groupTitle} ({report.total} مورد)
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="userReport-list">
                  <List sx={{ maxHeight: "230px", overflowY: "auto" }}>
                    {report.title.map((item, index) => (
                      <ListItem
                        sx={{
                          background: index % 2 === 0 ? "#fff" : "#EDEFEF",
                          paddingRight: "4vw",
                        }}
                      >
                        {item}
                      </ListItem>
                    ))}
                  </List>
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      ) : (
        <TabsEmptyStyle text="گزارشات" />
      )}
    </>
  );
};

export default Reports;
